function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { MembershipForm as MembershipFormBase } from "@xo-union/tk-ui-membership-form";
import { useDispatch, useSelector } from "react-redux";
import { logIn, signUp, clearError, createErrorSelector, createInProgressSelector } from "@xo-union/store-membership-redux";
var useRenderRef = function useRenderRef(value) {
  var ref = React.useRef(value);
  ref.current = value;
  return ref;
};

/**
 * This component is the Redux wrapper around the membership form. It:
 * 1. is wired with the Membership SDK to support log in and sign up flows
 * 1. handles membership API errors and mounts an alert banner when appropriate
 * 1. handles client-side validation errors for email and password fields
 * 1. handles country-specific spam laws through the display of an email optin checkbox when appropriate. More details about this can be found in the [CanSpam](/packages/@xo-union/tk-ui-membership-form#canspam) documentation.
 */
var MembershipForm = function MembershipForm(props) {
  var initialFocusRef = props.initialFocusRef,
    formType = props.formType,
    onSignUpSuccess = props.onSignUpSuccess,
    onLogInSuccess = props.onLogInSuccess,
    additionalMembershipData = props.additionalMembershipData;
  var formRef = React.useRef();
  var fallbackEmailRef = React.useRef();
  var emailRef = initialFocusRef || fallbackEmailRef;
  var dispatch = useDispatch();
  var error = useSelector(createErrorSelector(formType));
  var inProgress = useSelector(createInProgressSelector(formType));
  var formTypeRef = useRenderRef(formType);
  var onLogIn = React.useCallback(function (_ref) {
    var valid = _ref.valid,
      data = _ref.data;
    if (valid) {
      dispatch(logIn(_objectSpread(_objectSpread({}, data), additionalMembershipData), onLogInSuccess));
    }
  }, [onLogInSuccess, additionalMembershipData]);
  var onSignUp = React.useCallback(function (_ref2) {
    var valid = _ref2.valid,
      data = _ref2.data;
    if (valid) {
      dispatch(signUp(_objectSpread(_objectSpread({}, data), additionalMembershipData), onSignUpSuccess));
    }
  }, [onSignUpSuccess, additionalMembershipData]);
  React.useEffect(function () {
    if (error && formRef.current) {
      var _emailRef$current;
      formRef.current.showError(error.data.userFacingError);
      dispatch(clearError(formTypeRef.current));
      (_emailRef$current = emailRef.current) === null || _emailRef$current === void 0 ? void 0 : _emailRef$current.focus();
    }
  }, [error]);
  return /*#__PURE__*/React.createElement(MembershipFormBase, _extends({
    ref: formRef,
    onLogIn: onLogIn,
    onSignUp: onSignUp,
    inProgress: inProgress
  }, props, {
    initialFocusRef: emailRef
  }));
};
process.env.NODE_ENV !== "production" ? MembershipForm.propTypes = {
  /**
   * Name of form
   */
  formType: PropTypes.oneOf(['SIGN_UP', 'LOG_IN']).isRequired,
  /**
   * Callback called when clicking on the Log In link
   */
  onClickLogIn: PropTypes.func.isRequired,
  /**
   * Callback called when clicking on the Sign Up link
   */
  onClickSignUp: PropTypes.func.isRequired,
  /**
   * Callback called when member successfully signs up
   */
  onSignUpSuccess: PropTypes.func.isRequired,
  /**
   * Callback called when member successfully logs in
   */
  onLogInSuccess: PropTypes.func.isRequired,
  /**
   * Metadata about user action necessary for sign up form
   */
  metadata: PropTypes.shape({
    userAction: PropTypes.string.isRequired,
    applicationName: PropTypes.string.isRequired
  }).isRequired,
  /**
   * Component to display as sign up view
   */
  SignUpView: PropTypes.func,
  /**
   * Component to display as log in view
   */
  LogInView: PropTypes.func,
  /**
   * Any additional information to be passed to membership, such as first and last name
   */
  additionalMembershipData: PropTypes.shape(),
  /**
   * Element to set as the initial focus
   */
  initialFocusRef: PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func
    })
  })
} : void 0;
export default MembershipForm;